"use strict";
/**
 * 自定義 ID 系統的類型定義
 */
Object.defineProperty(exports, "__esModule", { value: true });
